import { render, staticRenderFns } from "./saasSubscribeTab.vue?vue&type=template&id=40e56900"
import script from "./saasSubscribeTab.vue?vue&type=script&lang=js"
export * from "./saasSubscribeTab.vue?vue&type=script&lang=js"
import style0 from "./saasSubscribeTab.vue?vue&type=style&index=0&id=40e56900&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports